<template>
    <uppy
        :allowed-file-types="['application/pdf']"
        :endpoint="uploadPath"
        @file-uploaded="addFile"
        @complete="$emit('complete', $event)"
    />
</template>

<script>
import Uppy from './Uppy';

export default {
    name:       'FileUploader',
    components: {Uppy},
    computed:   {
        mediaId() {
            return this.$store.getters['media/mediaId'];
        },
        uploadPath() {
            return this.$dmv.env.API_DOMAIN + '/v1/files/upload?mediaId=' + this.mediaId;
        },
    },
    methods:    {
        addFile(file) {
            this.$store.dispatch('media/addFile', file);
        }
    }
}
</script>


